import { MenuOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { FC } from 'react'
import RewindQueueEntry from '../../../../../../../../types/api/rewind-queue-entry'
import GroupOperationsDropdown from './group-operations-dropdown'

interface RowSelectionColumnTitleProps {
    selected: RewindQueueEntry[]
    onMoved: () => void
}

const RowSelectionColumnTitle: FC<RowSelectionColumnTitleProps> = ({ selected, onMoved }) => {
    return selected.length > 0 ? (
        <GroupOperationsDropdown selected={selected} onMoved={onMoved} />
    ) : (
        <Tooltip title='Групповые операции, выберите строки'>
            <Button size='small' icon={<MenuOutlined />} />
        </Tooltip>
    )
}

export default RowSelectionColumnTitle
